// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';

import SessionStore from 'stores/SessionStore';


import ApiKiosk from 'PMT/api/ApiKiosk';
import ApiError from 'PMT/entities/ApiError';

import ActionTypes from 'constants/ActionTypes';

import KioskSettings from 'PMT/entities/restaurant/KioskSettings';

export default class KioskAction {

  //
  // Order settings - GET
  //

  static loadSettings() {
    ApiKiosk.getSettings(
      SessionStore.getRestaurantId(),
      KioskAction.receiveSettings,
      KioskAction.receiveSettingsError
    );
  }

  static receiveSettings(kioskSettings: KioskSettings) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_KIOSK_SETTINGS_SUCCESS,
      kioskSettings
    });
  }

  static receiveSettingsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_KIOSK_SETTINGS_FAILURE,
      apiError
    });
  }

  //
  // Order settings - UPDATE
  //

  static updateSettings(kioskSettings: KioskSettings, files) {
    ApiKiosk.putSettings(
      SessionStore.getRestaurantId(),
      kioskSettings,
      files,
      KioskAction.receiveUpdatedSettings,
      KioskAction.receiveUpdatedSettingsError
    );
  }

  static receiveUpdatedSettings(kioskSettings: KioskSettings) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_KIOSK_SETTINGS_SUCCESS,
      kioskSettings
    });
  }

  static receiveUpdatedSettingsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_KIOSK_SETTINGS_FAILURE,
      apiError
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/actions/KioskAction.js